import { CategoryCreateComponent } from './category/category-create/category-create.component';
import { CategoryListComponent } from './category/category-list/category-list.component';
import { AddElearningComponent } from './content/add-elearning/add-elearning.component';
import { TopicCreateComponent } from './topic/topic-create/topic-create.component';
import { FormatDateService } from '../../shared/services/format-date.service';
import { TopicListComponent } from './topic/topic-list/topic-list.component';
import { centerDynamicModalConfig } from '../../shared/helpers/modal.config';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MediaService } from '../../../api/api-services/media.service';
import { Component, inject, ViewChild } from '@angular/core';
import { eModalRoles } from '../../shared/models/modals';
import { MenuItem } from 'primeng/api';
import { ContentListComponent } from './content/content-list/content-list.component';

@Component({
  selector: 'app-elearning',
  templateUrl: './elearning.component.html',
  styleUrl: './elearning.component.scss'
})
export class ElearningComponent {


  @ViewChild(CategoryListComponent) categoryListComponent!: CategoryListComponent;
  @ViewChild(ContentListComponent) contentListComponent!: ContentListComponent;
  @ViewChild(TopicListComponent) topicListComponent!: TopicListComponent;

  private _mediaService = inject(MediaService)

  private _dialogService = inject(DialogService);

  public mediaUrl!: any;

  private dialogRef!: DynamicDialogRef;

    public splitButtonItems: MenuItem[] = [
    {
      label: 'Dodaj nowy rozdział',
      command: () => {
        this.openAddTopicModal();
      },
    },
    {
      label: 'Dodaj nowy dział',
      command: () => {
        this.openAddCategoryModal();
      },
    }
  ];


  //for Dev only
  getVideoUrl(resourceName: string): string {
    return this._mediaService.getVideoUrl(resourceName, 'mov', 1920, 1080);
  }

  openAddElearningModal(): void {
    this.dialogRef = this._dialogService.open(AddElearningComponent, {
      ...centerDynamicModalConfig,
      width: '1000px',
      header: 'Dodaj nowy wykład',
      draggable: true
    });

        this.dialogRef.onClose.subscribe((result) => {
      if (result === eModalRoles.SUCCESS) {
        if (this.contentListComponent) {
          this.contentListComponent.loadTopics();
        }
      }
    });
  }

  openAddCategoryModal(): void {
    this.dialogRef = this._dialogService.open(CategoryCreateComponent, {
      ...centerDynamicModalConfig,
      width: '1000px',
      header: 'Dodaj dział',
      draggable: true
    });

    this.dialogRef.onClose.subscribe((result) => {
      if (result === eModalRoles.SUCCESS) {
        if (this.categoryListComponent) {
          this.categoryListComponent.refreshCategories();
        }
      }
    });
  }

  openAddTopicModal(): void {
    this.dialogRef = this._dialogService.open(TopicCreateComponent, {
      ...centerDynamicModalConfig,
      width: '1000px',
      header: 'Dodaj rozdział',
      draggable: true
    });

    this.dialogRef.onClose.subscribe((result) => {
      if (result === eModalRoles.SUCCESS) {
        if (this.topicListComponent) {
          this.topicListComponent.refreshTopics();
        }
      }
    });
  }

  onTabChange(event: any): void {
    // Index 0 = Slajdy, 1 = Rozdziały wykładów, 2 = Działy wykładów
    if (event.index === 0 && this.contentListComponent) {
      this.contentListComponent.refreshTopics();
    }
  }
}
